'use strict';

class SidenavController {
  sidenav = Object;

  constructor(SidenavSvc) {
    var that = this;
    var updateSidenav = function(updatedSidenav) {
      that.sidenav = updatedSidenav;
    };
    SidenavSvc.registerObserverCallback(updateSidenav);
  }
}

SidenavController.$inject = ['SidenavSvc'];

export default ['SidenavSvc', SidenavController];
